import schedulesSlice from './schedules';


export default {
  schedulesSlice,
  
};
